import React, { useEffect, useState } from 'react';

export default function WorkExperienceModal({
  isOpen,
  onClose,
  initialCompany = '',
  initialJobTitle = '',
  initialStart = '',
  initialEnd = '',
  initialDetails = '',
  onSave,
  onEnhance,
}) {
  const [company, setCompany] = useState(initialCompany || '');
  const [jobTitle, setJobTitle] = useState(initialJobTitle || '');
  const [startDate, setStartDate] = useState(initialStart || '');
  const [endDate, setEndDate] = useState(initialEnd || '');
  const [details, setDetails] = useState(initialDetails || '');
  const [isEnhancing, setIsEnhancing] = useState(false);

  useEffect(() => {
    setCompany(initialCompany || '');
    setJobTitle(initialJobTitle || '');
    setStartDate(initialStart || '');
    setEndDate(initialEnd || '');
    setDetails(initialDetails || '');
  }, [initialCompany, initialJobTitle, initialStart, initialEnd, initialDetails, isOpen]);

  if (!isOpen) return null;

  const handleEnhance = async () => {
    if (!onEnhance) return;
    try {
      setIsEnhancing(true);
      const enhanced = await onEnhance(details || '');
      if (enhanced) setDetails(enhanced);
    } catch (err) {
      console.error('WorkExperienceModal enhance error', err);
    } finally {
      setIsEnhancing(false);
    }
  };

  const handleSave = () => {
    if (onSave) onSave({ company: company || '', jobTitle: jobTitle || '', startDate, endDate, details });
  };

  return (
    <div style={{ position: 'fixed', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1100, background: 'rgba(0,0,0,0.4)' }}>
      <div style={{ width: 720, maxWidth: '95%', background: '#fff', borderRadius: 6, padding: 20, boxShadow: 'rgba(0,0,0,0.2) 0px 6px 24px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
          <h3 style={{ margin: 0 }}>Edit Work Experience</h3>
          <button aria-label="Close" onClick={onClose} style={{ background: 'transparent', border: 'none', fontSize: 20, cursor: 'pointer' }}>×</button>
        </div>

        <label className="form-label" style={{ display: 'block', marginBottom: 6 }}>Company name</label>
        <input
          type="text"
          placeholder="Company name"
          value={company}
          onChange={(e) => setCompany(e.target.value)}
          className="section-input"
          style={{ width: '100%', marginBottom: 8 }}
        />

        <label className="form-label" style={{ display: 'block', marginBottom: 6 }}>Job title</label>
        <input
          type="text"
          placeholder="Job title"
          value={jobTitle}
          onChange={(e) => setJobTitle(e.target.value)}
          className="section-input"
          style={{ width: '100%', marginBottom: 8 }}
        />

        <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
          <div style={{ flex: 1 }}>
            <label className="form-label" style={{ display: 'block', marginBottom: 6 }}>Start date</label>
            <input className="section-input-date" type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} style={{ width: '100%' }} />
          </div>
          <div style={{ flex: 1 }}>
            <label className="form-label" style={{ display: 'block', marginBottom: 6 }}>End date</label>
            <input className="section-input-date" type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} style={{ width: '100%' }} />
          </div>
        </div>

        <label className="form-label" style={{ display: 'block', marginTop: 8, marginBottom: 6 }}>Responsibilities / details</label>
        <textarea
          rows={8}
          className="form-textarea"
          value={details}
          onChange={(e) => setDetails(e.target.value)}
          placeholder="Add responsibilities and achievements for this work entry."
          style={{ width: '100%', marginTop: 0 }}
        />

        <div style={{ display: 'flex', alignItems: 'center', marginTop: 12 }}>
          <div style={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
            <button type="button" className="btn btn-secondary" onClick={handleEnhance} disabled={isEnhancing}>{isEnhancing ? 'Enhancing...' : 'Enhance'}</button>
          </div>
          <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
            <button type="button" className="btn btn-primary" onClick={() => { handleSave(); onClose(); }}>Save</button>
          </div>
        </div>
      </div>
    </div>
  );
}
